import { Row, Col } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { IoMdPrint } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoSearchSharp } from "react-icons/io5";

interface TableToolbarProps {
  data: any[];
  filterText: string;
  setFilterText: (val: string) => void;
  onSearch: () => void;
  onExportExcel: () => void;
  onPrint: () => void;
}

const TableToolbar = ({
  data,
  filterText,
  setFilterText,
  onSearch,
  onExportExcel,
  onPrint,
}: TableToolbarProps) => (
  <Row className="mt-3 align-items-center">
    {/* <Col className="d-flex gap-2 flex-wrap">
      <Btn color="primary" onClick={onPrint} disabled={data.length === 0}>
        <IoMdPrint size={20} /> Print
      </Btn>
      <Btn color="primary" onClick={onExportExcel} disabled={data.length === 0}>
        <PiMicrosoftExcelLogoFill size={20} /> Excel
      </Btn>
    </Col> */}
    <Col md="12" className="ms-auto">
      <div className="input-group">
        <input
          type="text"
          className="form-control mr-3"
          placeholder="Search..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <button
          className="btn btn-primary rounded-pill"
          onClick={(e) => {
            e.preventDefault();
            onSearch();
          }}
        >
          <IoSearchSharp /> Search
        </button>
      </div>
    </Col>
  </Row>
);

export default TableToolbar;
